<template>
  <div>
    <div class="text-ss">
      {{ messageInfo.author }} –
      {{ $t('new comment') }}
    </div>
    {{ messageInfo.message }}
    <div class="text-ss mt-16">
      {{ $t('Item info') }}
    </div>
    <div>
      {{ messageInfo.list }}
      –
      {{ messageInfo.description }}.
    </div>
    <Button
      :overlay="isMine"
      size="small"
      type="func"
      @click="openComment(message.tender_offer_row_comment)"
    >
      {{ $t('Open comment') }}
    </Button>
  </div>
</template>

<script>
  import get from 'lodash.get';
  import { isIncomingTenderPage, isTenderPage } from '@/utils/route-matcher';
  import { mapActions } from 'vuex';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'CommentMessage',
    components: { Button },
    props: {
      message: {
        type: Object,
        required: true,
      },
      isMine: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      messageInfo() {
        return {
          message: get(this.message, 'message', ''),
          author: get(this.message, 'tender_offer_row_comment.author.name', ''),
          list: get(
            this.message,
            'tender_offer_row_comment.tender_offer_row.tender_row.api_row.api_list.title',
            ''
          ),
          description: get(
            this.message,
            'tender_offer_row_comment.tender_offer_row.tender_row.api_row.description_of_works',
            ''
          ),
        };
      },
    },
    methods: {
      ...mapActions('incomingTender', ['changeSelectedVersion']),
      async openComment(comment) {
        let listId = get(comment, 'tender_offer_row.tender_row.api_row.api_list.id');
        let id = get(
          comment,
          isTenderPage(this.$route) ? 'tender_offer_row.tender_row.row_id' : 'tender_offer_row_id'
        );

        let tabId = comment?.tender_offer_row_id;
        let versionId = comment?.tender_offer_row?.tender_offer_version_id;
        let offerId = comment?.tender_offer_row?.tender_offer_version?.tender_offer?.id;

        if (listId && id) {
          if (isTenderPage(this.$route) && offerId && versionId) {
            await this.$router.push({
              name: 'tender-list',
              params: { tenderListId: listId },
              query: {
                position: id,
                tab: tabId,
                version: `${offerId}_${versionId}`,
              },
            });
          } else if (isIncomingTenderPage(this.$route) && versionId) {
            await this.$router.push({
              name: 'incoming-tender-list',
              params: { incomingTenderListId: listId },
              query: {
                version: versionId,
                position: id,
              },
            });
          } else if (isIncomingTenderPage(this.$route)) {
            await this.$router.push({
              name: 'incoming-tender-list',
              params: { list: listId },
            });
          }
        }
      },
    },
  };
</script>
